import {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  Carousel,
  CarouselItem,
} from '~/common/FabricInvitation/EventCreateDesign/components/Onboarding/components/Carousel/Carousel';
import {Step} from '~/common/FabricInvitation/EventCreateDesign/components/Onboarding/components/Step/Step';
import {selectTemplateName} from '~/common/FabricInvitation/reducers/fabricTemplate/selectors';
import {UPDATE_DESIGN_OPTIONS} from '~/common/fabric/reducers/fabricDesign/constants';
import {selectForceShowOnboardingModal} from '~/common/fabric/reducers/fabricDesign/selectors';
import {isFabricWebview} from '~/common/utils/webview';
import {Overlay} from '~library/atoms/Overlay';
import './Onboarding.sass';

const steps = [
  {
    title: 'New design tools you’ll love',
    subtitle: 'An improved Evite experience',
    video: '//g0.evitecdn.com/invitation/designs/onboarding-intro',
  },
  {
    title: 'Improved text editing',
    subtitle: 'More ways to customize',
    video: '//g0.evitecdn.com/invitation/designs/onboarding-text',
  },
  {
    title: 'It’s all in the details',
    subtitle: 'Easy-to-access info',
    video: '//g0.evitecdn.com/invitation/designs/onboarding-eventdetails',
  },
  {
    title: 'Seamless gifting',
    subtitle: 'Effortlessly add a registry',
    video: '//g0.evitecdn.com/invitation/designs/onboarding-gifting',
  },
];

export const Onboarding = () => {
  const templateName = useSelector(selectTemplateName);
  const key = `show_onboarding_creation_flow_${templateName}`;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [open, setOpen] = useState(!(localStorage.getItem(key) === 'false'));

  const forceShowOnboardingModal = useSelector(selectForceShowOnboardingModal);
  const dispatch = useDispatch();

  // biome-ignore lint/correctness/useExhaustiveDependencies: deps
  useEffect(() => {
    if (forceShowOnboardingModal) {
      localStorage.setItem(key, 'true');
    }
  }, [forceShowOnboardingModal]);

  const onClickCloseHandler = useCallback(() => {
    setOpen(false);
    localStorage.setItem(key, 'false');
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {forceShowOnboardingModal: false},
    });
  }, [key, dispatch]);

  const activeIndexCallbackHandler = useCallback((index) => setCurrentIndex(index), []);

  if (isFabricWebview() || (!open && !forceShowOnboardingModal)) {
    return null;
  }

  return (
    <Overlay
      open={forceShowOnboardingModal}
      title={steps[currentIndex].title}
      modalId="create_flow__onboarding"
      onClose={onClickCloseHandler}
      closeOnClickOutside={false}
      closeOnEscKeyPress={false}
      overlayCloseBtnDataQAId="onboard-close"
      overlayDataImpressionTracking="true"
    >
      <Carousel activeIndexCallback={activeIndexCallbackHandler} onClickDone={onClickCloseHandler}>
        {steps.map((step, index) => (
          <CarouselItem key={step.title}>
            <Step step={step} isVisible={index === currentIndex} />
          </CarouselItem>
        ))}
      </Carousel>
    </Overlay>
  );
};
